// Stores
import { useResult } from "../../../../../shared/formContext/hooks/useResult";

// Components
import Table from "../../../../../components/Table/Table";

// Utils
import { utils } from "../../../../../helpers/index.js";

// WP react stuff
import { __ } from "@wordpress/i18n";

interface Installment {
    date: string;
    principalPaid: number;
    interestPaid: number;
    remainingBalance: number;
}

/**
 * Yearly-aggregated view of the same amortization schedule the chart uses —
 * one row per year (35 rows for a 420-month loan) instead of one per month,
 * which the shared Table component isn't built to page through on its own.
 */
const TableView: React.FC = () => {
    const { resultData } = useResult();
    const { response } = resultData;
    const installments: Installment[] = response?.data?.result?.results?.installments || [];

    let totalPrincipalPaid = 0;
    let totalInterestPaid = 0;
    const rows: { value: string; className?: string }[][] = [];

    installments.forEach((item, index) => {
        totalPrincipalPaid += item.principalPaid || 0;
        totalInterestPaid += item.interestPaid || 0;

        const isYearEnd = (index + 1) % 12 === 0;
        const isLastMonth = index === installments.length - 1;

        if (isYearEnd || isLastMonth) {
            rows.push([
                { value: String(Math.ceil((index + 1) / 12)) },
                { value: utils.toEuro(totalPrincipalPaid) },
                { value: utils.toEuro(totalInterestPaid) },
                { value: utils.toEuro(item.remainingBalance) },
            ]);
        }
    });

    return (
        <Table
            noMobile={undefined}
            firstRow={undefined}
            loadMoreBtn={undefined}
            hasMoreRows={undefined}
            onLoadMore={undefined}
            headers={[
                { value: __("Ano", "df-simulators") },
                { value: __("Capital pago", "df-simulators") },
                { value: __("Juros pagos", "df-simulators") },
                { value: __("Dívida", "df-simulators") },
            ]}
            data={rows}
        />
    );
};

export default TableView;
